import React from 'react'
import { getPlatformImg } from '../../../../helpers/getImgSrc'
import { getPlatformName } from '../../../../helpers/getPlatformName'
import './header_component.css'

const HeaderComponent = ({platform_id,is_account_linked,account_name,created_at,total_ads_linked,media_type}) => {

  return (
     <div className='w-100 bg-white custom_border custom-card link_campaigns_header'>
        <div className='link_campaigns_header_platform_container '>
          <div className='link_campaigns_header_logo'>
            <img src={getPlatformImg(platform_id)} alt="" />
          </div>
          <div className='link_campaigns_header_platform'>
            <h4>{getPlatformName(platform_id)}</h4>
            {is_account_linked && 
            <div className='link_campaigns_header_platform_badge'>
              <div className='link_campaigns_header_platform_badge_dot'></div>
              <p>Connected</p>
            </div>}
          </div>
        </div>

        <div className='link_campaigns_header_user_details_container'>
          <div className='row g-3'>
            <div className='col-md-6'>
             <p className='user_details_container_heading'>Connected As</p>
             <p className='user_details_container_data'>{account_name}</p>

            </div>
            <div className='col-md-6'>
            <p className='user_details_container_heading'>Connected On</p>
            <p className='user_details_container_data '>{created_at}</p>

            </div>
            <div className='col-md-6'>
            <p className='user_details_container_heading'>Linked {total_ads_linked} {media_type==="organic_social" ?"Posts":"Ads"}</p>
            <p className='user_details_container_data'>
              {media_type==="organic_social" ?"POSTS":"ADS"}
            </p>

            </div>


          </div>



        </div>


      </div>
  )
}

export default HeaderComponent